import { Box, Button, Typography, useTheme } from '@mui/material';
import { STRINGS } from '../../../constants';
import { SummaryDetails } from '../../../components/SummaryDetails';
import { CitysprintTextLogo } from './CitysprintTextLogo';
import { CitysprintSummaryQuoteDetails } from './CitysprintSummaryQuoteDetails';

export function SummaryRow({ label, value, labelColor = 'text.secondary' }) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: 1,
        mt: 1,
      }}
    >
      <Typography variant='body2' color={labelColor}>
        {label}
      </Typography>
      <Typography variant='body2' sx={{ textAlign: 'right' }}>
        {value}
      </Typography>
    </Box>
  );
}

export function CitysprintParcelOrderSummary({
  selectedQuoteOption,
  selectedVatAmount,
  canGoNext,
  nextStepPending = false,
  onNextStep,
}) {
  const theme = useTheme();

  const ex = selectedQuoteOption
    ? parseFloat(selectedQuoteOption.prices.excl)
    : NaN;
  const inc = selectedQuoteOption
    ? parseFloat(selectedQuoteOption.prices.incl)
    : NaN;
  let tax = 0;
  if (selectedVatAmount != null && !Number.isNaN(selectedVatAmount)) {
    tax = selectedVatAmount;
  } else if (!Number.isNaN(ex) && !Number.isNaN(inc)) {
    tax = inc - ex;
  }

  const price = {
    totalIncVatAmount: !Number.isNaN(inc) ? inc : 0,
    taxAmount: tax,
  };

  return (
    <Box
      sx={{
        position: 'sticky',
        top: `calc(var(--dpd-appbar-height, 0px) + ${theme.spacing(2)})`,
      }}
      data-testid='citysprint-parcel-summary'
    >
      <Box
        sx={{
          pl: { xs: 3, md: 0 },
          pr: { xs: 3, md: 0 },
        }}
      >
        <SummaryDetails
          price={price}
          basketItemsWithPrice={[]}
          displayItemsPriceDetails={false}
          displayInsurance={false}
          belowSummaryContent={<CitysprintTextLogo />}
          itemsContent={
            selectedQuoteOption ? (
              <CitysprintSummaryQuoteDetails quote={selectedQuoteOption} />
            ) : null
          }
        />

        <Box
          sx={{
            gap: 1,
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            variant='contained'
            type='button'
            disabled={!canGoNext || nextStepPending}
            onClick={onNextStep}
            sx={{
              flexGrow: 1,
              marginRight: { xs: 2, md: 0 },
              marginLeft: { xs: 2, md: 0 },
            }}
          >
            {STRINGS.NEXT_STEP}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
